import starsVideo from "../../../../assets/videos/stars.mp4";
import styles from "./StarfieldBackground.css";

/* Fills whatever positioned, clipped box its caller places it in — the same
   asset PageShell's own dark surface plays full-bleed, but meant for a
   smaller, contained panel instead. */
const StarfieldBackground = () => (
  <video
    aria-hidden
    className={styles.video}
    src={starsVideo}
    autoPlay
    muted
    loop
    playsInline
  />
);

export default StarfieldBackground;
